import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type IPrivateContactAlliance, privateContactAlliancesManager } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { type IByPrivateContactAllianceState } from './types';

const PRIVATE_CONTACT_ALLIANCE_MODULE = 'privateContactAlliance';

const state: IByPrivateContactAllianceState = {
    byAlliance: new Map()
};

const dataObjectModule = getDataObjectsModule<IPrivateContactAlliance>(privateContactAlliancesManager, 3);
const searchModule = getSearchModule<IPrivateContactAlliance>(privateContactAlliancesManager);

const privateContactAllianceModuleInstance = merge<unknown>(dataObjectModule, searchModule, { state, actions, mutations, getters });
store.registerModule(PRIVATE_CONTACT_ALLIANCE_MODULE, privateContactAllianceModuleInstance);

export { PRIVATE_CONTACT_ALLIANCE_MODULE };
